import React from "react";
import { observer } from "mobx-react";

import "./style/modal.scoped.scss";

export const ErrorCard = observer(({ error }) => {
    return <div className="error">{error}</div>;
});
